import React from "react";
import DeviceDetailRouteCore from "../DeviceDetailRoutePage";
import { useLazyGetDeviceByIdQuery } from "../../../store/storageRoles/devicesSharedApi";

/**
 * Depo (storage) firma kullanıcıları için cihaz detay sayfası.
 * Ağır detay mantığı paylaşılan çekirdekte; bu kabuk storage cihaz-detay
 * endpoint'ini geçirir.
 */
export default function StorageDeviceDetailRoutePage() {
  return (
    <DeviceDetailRouteCore
      useDeviceDetailQuery={useLazyGetDeviceByIdQuery}
      isDealer={false}
    />
  );
}
